/**
 * 날짜 포맷팅 함수
 * @param {string} dateString - 날짜 문자열
 * @returns {string} 포맷된 날짜
 */
export const formatDate = dateString => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  });
};

/**
 * 수익률 포맷팅 함수
 * @param {number} yieldValue - 수익률 값
 * @returns {string} 포맷된 수익률
 */
export const formatYield = yieldValue => {
  if (yieldValue === null || yieldValue === undefined) return '-';
  return Number(yieldValue).toFixed(3);
};

/**
 * 채권명에서 시리즈 추출
 * @param {string} bondName - 채권명
 * @returns {string} 시리즈명
 */
export const extractBondSeries = bondName => {
  if (!bondName) return '';
  const match = bondName.match(/\(([^)]+)\)/);
  return match ? match[1] : bondName;
};

/**
 * 채권 정렬 함수
 * @param {Array} bonds - 채권 배열
 * @returns {Array} 정렬된 채권 배열
 */
export const sortBonds = bonds => {
  return [...bonds].sort((a, b) => {
    // 기준채를 최상단으로
    if (a.isBenchmark && !b.isBenchmark) return -1;
    if (!a.isBenchmark && b.isBenchmark) return 1;

    // 잔존만기가 짧은 순 (maturityDate 기준)
    return new Date(a.maturityDate) - new Date(b.maturityDate);
  });
};

/**
 * 잔존만기 계산 함수
 * @param {string} maturityDate - 만기일
 * @returns {string} 잔존만기 문자열
 */
export const calculateRemainingTerm = maturityDate => {
  if (!maturityDate) return '-';

  const today = new Date();
  const maturity = new Date(maturityDate);

  // 월 단위 차이 계산
  let months = (maturity.getFullYear() - today.getFullYear()) * 12;
  months += maturity.getMonth() - today.getMonth();

  // 일자 차이를 고려하여 월 조정
  if (maturity.getDate() < today.getDate()) {
    months--;
  }

  // 음수인 경우 (만료된 경우)
  if (months < 0) {
    return '만료';
  }

  // 1년 이상인 경우
  if (months >= 12) {
    const years = Math.floor(months / 12);
    const remainingMonths = months % 12;
    if (remainingMonths === 0) {
      return `${years}년`;
    }
    return `${years}년 ${remainingMonths}개월`;
  }

  // 1년 미만인 경우
  return `${months}개월`;
};
